import { render } from "./EventModelThumbnail.vue?vue&type=template&id=1e7beea2&scoped=true"
import script from "./EventModelThumbnail.vue?vue&type=script&lang=js"
export * from "./EventModelThumbnail.vue?vue&type=script&lang=js"

import "./EventModelThumbnail.vue?vue&type=style&index=0&id=1e7beea2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7beea2"]])

export default __exports__